<asw-error-guidance [isSubPage]="isModal"></asw-error-guidance>
<div *ngFor="let item of alertWarningMessageList">
  <asw-alert-message [item]="item" [isWarning]="true" (closeEvent)="closeWarning($event)"></asw-alert-message>
</div>
<div *ngFor="let item of alertInfomationMessageList">
  <asw-alert-message
    [item]="item"
    [isCloseEnable]="item.isCloseEnable"
    (closeEvent)="closeInfomation($event)"
  ></asw-alert-message>
</div>
<div *ngFor="let item of alertInfomationDynamicMessageList">
  <asw-alert-message
    [item]="item"
    [isCloseEnable]="item.isCloseEnable"
    (closeEvent)="closeInfomationDynamic($event)"
  ></asw-alert-message>
</div>
